// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>6</span>&nbsp;&nbsp;O Israel, wait for the Lord,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;for with the Lord there is mercy;<br> </p> </div></div>";
// Exports
module.exports = code;